import { useEffect } from 'react';
import { isProdEnv } from '../util';

const gtmAuth = process.env.REACT_APP_GTM_AUTH
  ? `&gtm_auth=${process.env.REACT_APP_GTM_AUTH}`
  : '';
const gtmPreview = process.env.REACT_APP_GTM_ENV
  ? `&gtm_preview=${process.env.REACT_APP_GTM_ENV}`
  : '';
const gtmCookies = gtmPreview ? '&gtm_cookies_win=x' : '';

const NONPROD_GTM_SCRIPT = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({
      'gtm.start':new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+
      '${gtmAuth}${gtmPreview}${gtmCookies}';
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-KKLXW7');`;
const NONPROD_GTM_NO_SCRIPT = `<iframe 
    src="https://www.googletagmanager.com/ns.html?id=GTM-KKLXW7${
  gtmAuth}${gtmPreview}${gtmCookies}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const PROD_STAPE_SCRIPT = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({
'gtm.start':new Date().getTime(),event:'gtm.js'});
var f=d.getElementsByTagName(s)[0],j=d.createElement(s);
j.async=true;j.src="https://load.server.figopetinsurance.com/9jnxtwnnl.js?"+i;
f.parentNode.insertBefore(j,f);
})(window,document,
'script','dataLayer',
'1f=BQpTMCA1QyEnIjYgQ14YV15AX1EQFlMMBQkBBxEMBwQfGxwWGhsLRA8BAw%3D%3D');`;

const PROD_STAPE_NO_SCRIPT = `<iframe 
src="https://load.server.figopetinsurance.com/ns.html?id=GTM-KKLXW7"
 height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

/** Injects GTM scripts and noscript for GTM using environments */
const useGTM = () => {
  useEffect(() => {
    const scriptTemplate = isProdEnv
      ? PROD_STAPE_SCRIPT
      : NONPROD_GTM_SCRIPT;
    const noscriptTemplate = isProdEnv
      ? PROD_STAPE_NO_SCRIPT
      : NONPROD_GTM_NO_SCRIPT;

    const scriptEl = document.createElement('script');
    scriptEl.innerHTML = scriptTemplate;

    const noscriptEl = document.createElement('noscript');
    noscriptEl.innerHTML = noscriptTemplate;

    // Insert after Osano script
    document.head.insertBefore(
      scriptEl,
      document.getElementById('kameleoon-loader') || document.head.firstChild,
    );
    document.body.insertBefore(noscriptEl, document.body.firstChild);

    return () => {
      document.head.removeChild(scriptEl);
      document.body.removeChild(noscriptEl);
    };
  }, []);
};

export { useGTM };
